import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { FilesService } from 'src/app/core/services/files.service';
import { ConfirmDeleteRasComponent } from '../../confirm-delete-ras/confirm-delete-ras.component';
import {
  instrumentType,
  instrumentTypes,
  instruments,
} from '../../utils/instrumentTypes';
enum Texts {
  title = 'Otros instrumentos o productos vinculados al cliente',
  instrumentType = 'Tipo de instrumento o producto',
  instrumentNumber = 'Número del instrumento o producto',
  agency = 'Agencia de apertura',
  openingDate = 'Fecha de apertura',
  deadline = 'Fecha de cierre',
  file = 'Informe Complementario',
}
@Component({
  selector: 'others-instruments',
  templateUrl: './others-instruments.component.html',
  styleUrls: ['./others-instruments.component.scss'],
})
export class OthersInstrumentsComponent implements OnInit {
  public Texts = Texts;
  @Input() form: FormGroup;
  @Output() formChange = new EventEmitter<FormGroup>();

  file;
  constructor(
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly filesService: FilesService
  ) {}

  instrumentForm = this.fb.group({
    instrumentType: ['', Validators.required],
    instrumentNumber: [''],
    file: [''],
    agency: [''],
    openingDate: [''],
    deadline: [''],
  });

  public instrumentTypes = instrumentTypes;
  instrumentsT = instruments;
  requireds: boolean = false;

  get instrumentNumber() {
    return this.instrumentForm.get('instrumentNumber');
  }

  get instrumentType() {
    return this.instrumentForm.get('instrumentType');
  }
  get agency() {
    return this.instrumentForm.get('agency');
  }
  get openingDate() {
    return this.instrumentForm.get('openingDate');
  }

  instrumentChange() {
    const value: instrumentType = this.instrumentType.value;

    if (value.id != 0) {
      this.requireds = true;
      this.instrumentNumber.setValidators([Validators.required]);
      this.agency.setValidators([Validators.required]);
      this.openingDate.setValidators([Validators.required]);
    } else {
      this.requireds = false;
      this.instrumentNumber.clearValidators();
      this.agency.clearValidators();
      this.openingDate.clearValidators();
    }
    this.instrumentNumber.updateValueAndValidity();
    this.agency.updateValueAndValidity();
    this.openingDate.updateValueAndValidity();
    this.formChange.emit(this.form);
  }

  instruments = [];

  displayedColumns: string[] = [
    'instrumentType',
    'instrumentNumber',
    // 'file',
    'agency',
    'openingDate',
    'deadline',
    'options',
  ];
  dataSource;

  ngOnInit() {
    const { othersInstruments } = this.form.value;
    console.log(othersInstruments);
    if (othersInstruments?.length > 0) {
      this.instruments = othersInstruments;
      this.dataSource = new MatTableDataSource(this.instruments);
    }
  }

  editing = null;

  setToEdit(index) {
    const values = this.instruments[index];
    this.editing = index;
    this.instrumentForm.patchValue(values);
    this.file = values.file.name;
    this.instrumentChange();
  }

  edit() {
    const values = this.instrumentForm.value;
    this.instruments[this.editing] = values;
    this.instrumentForm.reset();
    this.updateItems();
    this.editing = null;
  }

  cancelEdit() {
    this.instrumentForm.reset();
    this.editing = null;
  }

  delete(index) {
    this.dialog
      .open(ConfirmDeleteRasComponent, {
        data: {
          title: '¿Seguro que deseas eliminar a este instrumento/producto?',
        },
      })
      .afterClosed()
      .subscribe({
        next: (result) => {
          if (result) {
            this.instruments.splice(index, 1);
            this.updateItems();
          }
        },
      });
  }

  updateItems() {
    this.dataSource = new MatTableDataSource(this.instruments);
    this.form.controls.othersInstruments.setValue(this.instruments);
    this.formChange.emit(this.form);
  }

  add() {
    const values = this.instrumentForm.value;
    this.instruments.push(values);
    this.instrumentForm.reset();
    this.updateItems();
  }

  addFile() {
    const input = document.createElement('input');
    input.type = 'file';
    console.log('Agrego;;;;;;;;;;;;;;;;;;;');
    input.click();
    input.onchange = (ev: any) => {
      const file: File = ev.target.files[0];
      console.log(file);
      const formData = new FormData();
      formData.append('file', file);
      this.filesService.upload(formData).subscribe({
        next: (url) => {
          const newFile = {
            url,
            name: file.name,
          };
          // this.instrumentForm.value.file = newFile
          this.instrumentForm.get('file').setValue(newFile);
          this.file = newFile.name;
          // this.filesChange.emit(this.files);
          // if (this.isEditing) {
          //   this.newFiles.push(newFile);
          //   this.newFilesChange.emit(this.newFiles);
          // }
        },
      });
    };
  }
  download(index) {
    const values = this.instruments[index];
    const path = values.file.url + `?name=${values.file.name}&download=true`;
    var a = document.createElement('a');
    a.href = path;
    a.download = path.substr(path.lastIndexOf('/') + 1);
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}
